import { useInputState } from './useInputState';

const validations = [
  {
    validate: (value) => value && value.trim && !!value.trim(),
    errorMessage: 'streetNumberRequiredError'
  }
];

export function useStreetNumberInputState(options) {
  return useInputState({
    initialValue: '',
    validations,
    ...(options || {})
  });
}
